<script lang="ts">
    import {OfferItem} from "../entities/OfferItem";
    import ThreeCanvas from "./ThreeCanvas.svelte";
    import SectionArrow from "./SectionArrow.svelte";
    import ItemInfo from "./ItemInfo.svelte";

    export let offerItems: OfferItem[];
    export let currentItemIndex = 0
    export let currentItem: OfferItem
    export let modalId: number

    function updateFormData(data: any) {
        currentItem = currentItem.copy(data)
        offerItems[currentItemIndex] = currentItem
    }

    let timer;
    const debounce = v => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            v();
        }, 200);
    }
</script>

{#if currentItem.measuredModel != null}
    <SectionArrow/>

    <div class="w-full relative">
        <div id="info" class="flex-row items-center lg:absolute left-0 text-center w-full lg:w-80 z-10">
            <ItemInfo offerItem={currentItem} updateFormData={updateFormData}/>
        </div>
        <ThreeCanvas bind:modalId={modalId} offerItem={currentItem} updateFormData={updateFormData}/>
    </div>
{/if}
